// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nfont13[data-v-699ea057] {\n  font-size:13px;\n}\n", ""]);
// Exports
module.exports = exports;
